const getLandingRouteFromPath = (path, landingPrefix) => ({
  route: 'landing',
  params: {
    landingPrefix,
    path: path.match(/[^/]+$/)[0],
  },
  router: path.startsWith(`/${landingPrefix}/`),
});

export default getLandingRouteFromPath;
